// extracted by mini-css-extract-plugin
module.exports = {"screenReaderText":"Container_screenReaderText__3JVAc","container":"Container_container__3eZVY","isFullWidth":"Container_isFullWidth__35nol"};